import { t } from 'ttag';

const STEP_TITLES = [
  {
    id: 0,
    name: t`Patient information`,
  },
  {
    id: 1,
    name: t`Patient contact`,
  },
  {
    id: 2,
    name: t`Study information`,
  },
  {
    id: 3,
    name: t`Diagnosis`,
  },
  {
    id: 4,
    name: t`Verify ECG signal`,
  },
];

const BIODIRECT_STEP_TITLES = [
  {
    id: 0,
    name: t`Patient information`,
  },
  {
    id: 1,
    name: t`Patient contact`,
  },
  {
    id: 2,
    name: t`Study information`,
  },
  {
    id: 3,
    name: t`Diagnosis`,
  },
];

const STUDY_CATEGORY = {
  BIOFLUX_DIRECT: 'BiofluxDirect',
  BIOFLUX: 'Bioflux',
};

export { BIODIRECT_STEP_TITLES, STEP_TITLES, STUDY_CATEGORY };
